import React, { useState } from 'react';
import { cx } from '@emotion/css';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import { ix } from '../../../utils/ix';
import { IconButton } from '../../atoms';
import useStyles from './Banner.styles';
export function Banner(props) {
    const classes = useStyles();
    const [isOpen, setIsOpen] = useState(true);
    const isControlledByProps = props.open !== undefined;
    const onIconButtonClick = () => {
        if (props.onClose) {
            props.onClose();
        }
        if (!isControlledByProps) {
            setIsOpen(false);
        }
    };
    return (React.createElement(Box, { className: cx(props.className, classes.root, {
            highlighted: props.highlighted,
        }), id: props.id },
        React.createElement(Collapse, { id: ix(props.id, 'collapse'), in: isControlledByProps ? props.open : isOpen },
            React.createElement(Alert, { className: classes.alert, id: ix(props.id, 'content'), action: !props.hideCloseIcon ? (React.createElement(IconButton, { className: classes.iconButton, id: ix(props.id, 'close-icon'), disabled: props.disableClosing, size: "small", onClick: onIconButtonClick },
                    React.createElement(CloseIcon, { fontSize: "inherit" }))) : undefined, icon: false }, props.children))));
}
//# sourceMappingURL=Banner.js.map